import React from 'react'
import { BsCaretRight } from 'react-icons/bs'
import styles from '../componentsStyles/Stacks.module.css'

const StacksLarea = () => {
  return (
    <div className={styles.larea}>
      <div className={styles.sticky}>

        <div className={styles.lareaContent}>

          <input type="checkbox"  id="stack-cb" className={styles.stcb} />
          <label htmlFor="stack-cb"> Themes <BsCaretRight className={styles.icon}/></label>
          <div className={styles.wrapper}>
            <div>
              <div className={styles.lareaSection}>
                  <a href ='/docs/stacks#stacks-mern'>MERN</a>
                  <a href ='/docs/stacks#stacks-mern-db'> Database      </a>
                  <a href ='/docs/stacks#stacks-mern-api'> API           </a>
                  <a href ='/docs/stacks#stacks-mern-auth'> Authentication</a>
                  <a href ='/docs/stacks#stacks-mern-others'> Other packages</a>
                  <a href="/docs/stacks#stacks-mern-deployment">
                    Deployment
                  </a>
                </div>
                <div className={styles.lareaSection}>
                  <a href='/docs/stacks#stacks-t3'> T3            </a>
                  <a href ='/docs/stacks#stacks-t3-db'> Database          </a>
                  <a href ='/docs/stacks#stacks-t3-api'> API              </a>
                  <a href ='/docs/stacks#stacks-t3-auth'> Authentication  </a>
                  <a href ='/docs/stacks#stacks-t3-others'> Other packages</a>
                  <a href ='/docs/stacks#stacks-t3-deployment'> Deployment</a>
                </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  )
}

export default StacksLarea